import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { useAddOrUpdateAccessControls } from "../hooks/useConfiguration";

interface Props {
  data: any;
}

const AccessControlForm: React.FC<Props> = ({ data }) => {
  console.log("datassssssssssss", data);
  const [mailFrom, setMailFrom] = useState("");
  const [fromName, setFromName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [dailyReportEmails, setDailyReportEmails] = useState("");
  const [otherEmails, setOtherEmails] = useState("");

  useEffect(() => {
    if (data?.data) {
      setMailFrom(data.data.MailFrom || "");
      setFromName(data.data.FromName || "");
      setAdminEmail(data.data.AdminEmail.toString() || "");
      setDailyReportEmails(data.data.DailyReportEmails || "");
      setOtherEmails(data.data.AdminCc || "");
    }
  }, [data?.data]);
  const { mutate: AddOrUpdateAccessControls } = useAddOrUpdateAccessControls();
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const isUpdate = data?.data?.EcId;
    const submittedData = {
      id: isUpdate ? data?.data?.id : undefined,
      MailFrom: mailFrom,
      FromName: fromName,
      AdminEmail: adminEmail,
      DailyReportEmails: dailyReportEmails,
      AdminCc: otherEmails,
    };

    console.log(
      isUpdate ? "Updating Data..." : "Adding Data...",
      submittedData
    );
    if (data) {
      console.log("Updating Data:", submittedData);
    } else {
      console.log("Adding Data:", submittedData);
    }
    AddOrUpdateAccessControls(submittedData, {
      onSuccess: () => {
        console.log(
          isUpdate
            ? "Access control updated successfully!"
            : "Access control added successfully!"
        );
      },
      onError: (error) => {
        console.error("Error saving access control:", error);
      },
    });
  };
 
  return (
    <Card className="p-3 shadow-sm">
      <CardBody>
        <h4>Access Control Configuration</h4>
        <p style={{ color: "#767676" ,marginTop:8}}>Enter access control details</p>
        <form onSubmit={handleSubmit}>
          <div className="row mt-3">
            <div className="col-md-6 mb-3">
              <label className="form-label">Mail From</label>
              <input
                className="form-control"
                type="text"
                name="mailFrom"
                value={mailFrom}
                onChange={(e) => setMailFrom(e.target.value)}
                required
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                  backgroundColor:'#fff'
                }}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">From Name</label>
              <input
                className="form-control"
                type="text"
                name="fromName"
                value={fromName}
                onChange={(e) => setFromName(e.target.value)}
                required
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                  backgroundColor:'#fff'
                }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Admin Email</label>
              <input
                className="form-control"
                type="text"
                name="adminEmail"
                value={adminEmail}
                onChange={(e) => setAdminEmail(e.target.value)}
                required
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                  backgroundColor:'#fff'
                }}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Daily Report Emails</label>
              <input
                className="form-control"
                type="text"
                name="dailyReportEmails"
                value={dailyReportEmails}
                onChange={(e) => setDailyReportEmails(e.target.value)}
                required
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                  backgroundColor:'#fff'
                }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Other Emails</label>
              <input
                className="form-control"
                type="text"
                name="otherEmails"
                value={otherEmails}
                onChange={(e) => setOtherEmails(e.target.value)}
                required
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                  backgroundColor:'#fff'
                }}
              />
            </div>
          </div>

          <div className="d-flex justify-content-start mt-3 gap-2">
            <Btn
              style={{ backgroundColor: "#43B9B2", color: "white" }}
              type="submit"
            >
              Submit
            </Btn>
            <Btn
              style={{
                backgroundColor: "#F9FAFC",
                color: "#000",
                border: "1px solid #E0E0E0",
              }}
              type="button"
            >
              Cancel
            </Btn>
          </div>
        </form>
      </CardBody>
    </Card>
  );
};

export default AccessControlForm;
